import React, { useContext } from 'react';
import Layout from '../components/Layout';
import TitleCard from '../components/TitleCard';
import SlideShow from '../components/SlideShow';
import Socials from '../components/Socials';
import FooterStack from '../components/FooterStack';
import {
  Grommet,
  Stack,
  Box,
  Main,
  Image,
  Carousel,
  Grid,
  ResponsiveContext,
} from 'grommet';
import { light } from 'grommet/themes';

import config from '../../config';
/* import '../assets/sass/main.scss';
import { Box } from 'grommet';
 */
const imgArray = [
  /*   'usc-fountain-library.jpg',
   */
  'sunflower.jpg',
  'jabbawokeez-duo.jpg',
  'grad-group.jpg',
  'rose-outside-fountain.jpg',

  /*   
  'brock_1_05.jpg',
  'suspenders_6.jpg',
  'brock_1_01.jpg',
  'tiff3.jpg',
  'brock_1_02.jpg',
  'jabbawokeez-duo.jpg',
  'pic01.jpg',
  'brock_1_09.jpg',
  'grad-group-pch.jpg',
  'fusion1.jpg',
  'make-wish-girl.jpg',
  'scott2.jpg',
  'pic43.jpg',
  'brock_1_06.jpg',
  'brock_1_10.jpg',
  'brock_1_03.jpg',
  'annenberg-chrys-moon_2.jpg',
  'brock_1_04.jpg',
  'brock_1_07.jpg',
  'xtina-grunge.jpg',
  'brock_1_08.jpg', */
];
/*   'https://d3dchd37g3pi7w.cloudfront.net/usc-fountain-library.jpg',
 */
const imgCDNArray = [
  'https://d3dchd37g3pi7w.cloudfront.net/sparrow-ronald.jpg',
  'https://d3dchd37g3pi7w.cloudfront.net/scott2.jpg',
  'https://d3dchd37g3pi7w.cloudfront.net/lyle.jpg',
  'https://d3dchd37g3pi7w.cloudfront.net/amari.jpg',
  'https://d3dchd37g3pi7w.cloudfront.net/brock_1_10.jpg',
  'https://d3dchd37g3pi7w.cloudfront.net/sparrow-ronald.jpg',
  'https://d3dchd37g3pi7w.cloudfront.net/sunflower.jpg',
  'https://d3dchd37g3pi7w.cloudfront.net/majestic-bird-raven.jpg',
  'https://d3dchd37g3pi7w.cloudfront.net/suspenders_6.jpg',
  'https://d3dchd37g3pi7w.cloudfront.net/brock_1_01.jpg',
  'https://d3dchd37g3pi7w.cloudfront.net/pic43.jpg',
  'https://d3dchd37g3pi7w.cloudfront.net/brock_1_06.jpg',
  'https://d3dchd37g3pi7w.cloudfront.net/brock_1_03.jpg',
  'https://d3dchd37g3pi7w.cloudfront.net/tiff3.jpg',
  'https://d3dchd37g3pi7w.cloudfront.net/brock_1_02.jpg',
  'https://d3dchd37g3pi7w.cloudfront.net/jabbawokeez-duo.jpg',
  'https://d3dchd37g3pi7w.cloudfront.net/pic01.jpg',
  'https://d3dchd37g3pi7w.cloudfront.net/rose-outside-fountain.jpg',
  'https://d3dchd37g3pi7w.cloudfront.net/brock_1_09.jpg',
  'https://d3dchd37g3pi7w.cloudfront.net/zack-grunge.jpg',
  'https://d3dchd37g3pi7w.cloudfront.net/grad-group-pch.jpg',
  'https://d3dchd37g3pi7w.cloudfront.net/fusion1.jpg',
  'https://d3dchd37g3pi7w.cloudfront.net/make-wish-girl.jpg',
  'https://d3dchd37g3pi7w.cloudfront.net/brock_1_05.jpg',
  'https://d3dchd37g3pi7w.cloudfront.net/grad-group.jpg',

  'https://d3dchd37g3pi7w.cloudfront.net/annenberg-chrys-moon_2.jpg',
  'https://d3dchd37g3pi7w.cloudfront.net/brock_1_04.jpg',
  'https://d3dchd37g3pi7w.cloudfront.net/brock_1_07.jpg',
  'https://d3dchd37g3pi7w.cloudfront.net/xtina-grunge.jpg',
  'https://d3dchd37g3pi7w.cloudfront.net/brock_1_08.jpg',
];
/*   
'junelyn-committee.jpg',
`rose-2.jpg`,
'flower-heritage-hall.jpg',
'traveler-day.jpg','
butterfly-side.jpg',
 */

const customCarouselProps = {
  carousel: {
    animation: {
      duration: 4000,
    },
    icons: {
      color: '#e3e3e3',
    },
  },
};

const settings = {
  images: imgArray,
  // Delay.
  delay: 5000,
};

const ResponsiveGrid = ({ children, ...props }) => {
  /*   const size = React.useContext(ResponsiveContext);
   */ return (
    <Grid justifyContent="center" {...props}>
      {children}
    </Grid>
  );
};

const IndexPage = () => {
  const mappedImages = imgCDNArray.map((imgName) => {
    return <Image margin="xsmall" fit="contain" src={imgName} />;
  });
  return (
    <Grommet full theme={customCarouselProps} themeMode={'dark'}>
      <ResponsiveGrid
        className="main-body"
        fill
        rows={['medium', 'flex', 'small']}
        columns={['10%', 'flex', '10%']}
        areas={[
          { name: 'header', start: [1, 0], end: [1, 0] },
          { name: 'body', start: [1, 1], end: [1, 1] },
          { name: 'footer', start: [1, 2], end: [1, 2] },
        ]}
      >
        <Box
          focusIndicator={false}
          alignSelf="center"
          pad={'large'}
          gridArea={'header'}
          animation={{
            type: 'fadeIn',
            delay: 0,
            duration: 4000,
          }}
        >
          <TitleCard />
        </Box>
        <Box
          justify="center"
          gridArea={'body'}
          animation={[
            {
              type: 'fadeIn',
              delay: 2000,
              duration: 5000,
            },
            {
              type: 'slideDown',
              delay: 2000,
              duration: 5000,
            },
          ]}
        >
          <Carousel fill controls={false} play={6000}>
            {mappedImages}
          </Carousel>
        </Box>
        <Box
          justify="end"
          gridArea={'footer'}
          align="center"
          pad="large"
          animation={{
            type: 'fadeIn',
            delay: 6000,
            duration: 3000,
          }}
        >
          <FooterStack />
        </Box>
      </ResponsiveGrid>
      <SlideShow settings={settings} />
    </Grommet>
  );
};
export default IndexPage;
